import type { FC } from 'react';

import type { ChatType } from 'config/types';
import type { ChatHook, ChatProps } from './types';
import useLiveChat from './useLiveChat';

const chatsMap: { [T in ChatType]: ChatHook<T> } = {
  disabled: () => null,
  livechat: useLiveChat,
};

const Chat: FC<ChatProps> = ({ config }) => {
  const { type, ...rest } = config;
  const hook = chatsMap[type] as ChatHook<typeof type>;
  hook(rest);

  return null;
};

export default Chat;
